module.exports = __webpack_public_path__ + "static/media/freeze4@3x.1d3da350.png";